export default () => ({
  status: "authenticating",
  user: null,
});
